import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@material-ui/core';
import { renderAnswer } from './renderAnswer';
export function AnswerContent(_a) {
    var className = _a.className, contents = _a.contents, skillApi = _a.skillApi, cardId = _a.cardId;
    return (_jsx("div", { className: "faq-answer-content__answer-wrapper", children: contents.map(function (content, i) {
            if (!content) {
                return null;
            }
            return (_jsx(Typography, { paragraph: true, component: "div", className: className, children: renderAnswer(content, skillApi, cardId) }, "".concat(i, "--").concat(content.text)));
        }) }));
}
//# sourceMappingURL=AnswerContent.js.map